// extracted by mini-css-extract-plugin
export default {"button":"version-check_button__nah1j","fadeIn":"version-check_fadeIn__EL6wm","mainMsg":"version-check_mainMsg__HpVyz"};